import { defineMessages } from 'react-intl';

export const gridSwitcherMessages = defineMessages({
  small: { id: 'gridSwitcher.small', defaultMessage: 'S' },
  medium: { id: 'gridSwitcher.medium', defaultMessage: 'M' },
  large: { id: 'gridSwitcher.large', defaultMessage: 'L' },
  select: { id: 'gridSwitcher.select', defaultMessage: 'Select Grid {size}' },
});
